'use strict';

module.exports = {
    profile: [
        'UOCCII:',
        'items',
        'DYN_USER_ID',
        'DYN_USER_CONFIRM',
        'JSESSIONID',
        'OrderIdCookie'
    ]
};
